import { createI18n } from 'vue-i18n';

const DEFAULT_LOCALE: dpost.i18n.language = 'ko';

async function loadLocaleMessages() {
  const modules = import.meta.glob('../assets/locales/*.json');
  const messages: Record<string, any> = {};

  for (const path in modules) {
    const module = (await modules[path]()) as { default: any }; // JSON 파일 로드
    const locale = path.match(/([A-Za-z0-9-_]+)\.json$/i)?.[1];
    if (locale) messages[locale] = module.default;
  }

  return messages;
}

// setupI18n은 main.ts에서 createPinia() 이전에 호출되므로 pinia 스토어 대신 localStorage에서 직접 조회
function readPersistedLocale(): dpost.i18n.language {
  try {
    const raw = localStorage.getItem('dpost-v1');
    if (!raw) return DEFAULT_LOCALE;
    const data = JSON.parse(raw);
    return data?.i18n?.locale ?? DEFAULT_LOCALE;
  } catch {
    return DEFAULT_LOCALE;
  }
}

export async function setupI18n() {
  const messages = await loadLocaleMessages();

  return createI18n({
    legacy: false,
    locale: readPersistedLocale(),
    fallbackLocale: DEFAULT_LOCALE,
    globalInjection: true,
    messages,
  });
}
